<template>
  <div class="w-100 mx-3 pt-2 pb-4">
    <div class="animated fadeIn">
        <div class="pt-4 justify-content-between" style="display: flex; gap: .3rem;">
          <div>
            <h5 class="text-third m-0"><i class="fas fa-address-card" /> Regras de Movimentação do Quadro</h5>
          </div>
          <div class="text-right">
            <button type="button" class="btn rounded btn-third btn-sm" v-on:click="openNewRuleModal" v-b-tooltip.hover title="Clique para adicionar uma nova regra"> <i class="fas fa-plus-circle" /> Adicionar</button>&nbsp;
          </div>
        </div>

        <div class="table-responsive pt-2" v-if="rules && rules.length">
            <table class="table table-hover" style="'border: 1px solid #dcdede;'">
              <thead class="thead-third" style="border: solid 1px #04a791;">
                <tr>
                  <th class="text-center" style="font-size: 14px;">TIPO</th>
                  <th class="text-center" style="font-size: 14px;">TEMPO</th>
                  <th class="text-center" style="font-size: 14px;">ETAPA A MOVER</th>
                  <th class="text-center" style="font-size: 14px;">AÇÕES</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(obj, index) in rules" :key="index">
                  <td class="text-center">{{obj.tipoRegra}}</td>
                  <td class="text-center">{{`${obj.tempoAtraso} horas`}}</td>
                  <td class="text-center">{{obj.boardColumn.nome}}</td>
                  <td class="text-center" style="font-size: 16px; cursor: pointer;">
                    <i @click="onEdit(obj)" class="fas fa-edit mr-1 text-third" ></i>
                    <i @click="toggleInative(obj)" class="ml-1"
                    :class="obj.inative ? 'fas fa-check text-success' : 'fas fa-minus-circle text-danger'"
                    v-b-tooltip.hover :title="obj.inative ? 'Clique para ativar' : 'Clique para inativar'"
                    ></i>
                    </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            Nenhum registro de regra, <strong @click="openNewRuleModal" style="cursor: pointer">clique para adicionar</strong>
          </div>

    <ModalNewRule
      v-if="newRuleModalOpen"
      ref="ModalNewRule"
      :isEditing="isEditing"
      :boardObj="boardObj"
      v-on:Reload="updateAndClose"
      v-on:HideModal="closeNewRuleModal"
    />
    </div>
  </div>
  </template>
<script>
import MovAutoCardRepository from '@/shared/http/repositories/crm/movimentacaoAutoCard.js'

import { toast } from '@/shared/utils/UIHelper'
import ModalNewRule from '@/views/private/crm/board/modal/collumns/movimentacao-quadro/ModalNewRule.vue'
import columnRuleTypes from '@/views/private/crm/board/modal/collumns/movimentacao-coluna/enumTiposRegra.js'

export default {
  name: 'TableMovimentacaoQuadro',
  props: {
    boardObj: {
      type: Object,
      required: () => ({})
    }
  },
  data () {
    return {
      rules: [], // TODO: SET NULL BEFORE PROD
      newRuleModalOpen: false,
      ruleTypes: columnRuleTypes,
      isEditing: null
    }
  },
  components: { ModalNewRule },
  created () {
    this.setRulesOnTable()
  },
  methods: {
    openNewRuleModal () {
      this.newRuleModalOpen = true
    },
    closeNewRuleModal () {
      this.newRuleModalOpen = false
      this.isEditing = null
    },
    updateAndClose () {
      this.closeNewRuleModal()
      this.$emit('Update')
    },
    onEdit (obj) {
      this.isEditing = obj
      this.openNewRuleModal()
    },
    toggleInative (obj) {
      let id = obj.id

      let data = {}
      data.id = obj.id
      data.horas = obj.tempoAtraso
      data.boardColumnDestino = obj.boardColumn.id
      data.inative = !obj.inative

      MovAutoCardRepository.ChangeStatus(id, data)
        .then(() => {
          let message = !obj.inative ? 'Regra inativada com sucesso!' : 'Regra ativada com sucesso!'
          toast.success(message, 'Parabéns')
          this.$emit('Update')
        })
        .catch((e) => {
          toast.error('Não foi possível realizar a alteração.', 'Desculpe')
          console.error(e)
        })
    },
    setRulesOnTable () {
      if (this.boardObj && this.boardObj.movimentacaoAutoTempoBoard) this.formatRuleTime(this.boardObj.movimentacaoAutoTempoBoard)
    },
    formatTempo (obj) {
      switch (obj.tipoRegra) {
        case this.ruleTypes.TEMPO:
          return `${obj.tempoAtraso} horas`
        case this.ruleTypes.DIAS:
          return `${this.hoursToDays(obj.tempoAtraso)} dias`
        default:
          return obj.tempoAtraso
      }
    },
    formatRuleTime (rule) {
      if (rule) {
        this.rules.push({
          tipoRegra: this.ruleTypes.TEMPO,
          tempoAtraso: rule.horas,
          inative: rule.inative,
          boardColumn: {nome: rule.boardColumnDestino.nome,
            id: rule.boardColumnDestino.id},
          id: rule.id
        })
      }
    }
  }
}

</script>
  <style lang="scss">
  .formulate-input-element.formulate-input-element--textarea {
    max-width: 100% !important;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/collumns/movimentacao-quadro/TableMovimentacaoQuadro.vue